import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './top-menu-bar.scss';
import SearchBar from '../SearchBar';
import axios from 'axios';
import { API_URL } from '../../../redux/services';

function useOutsideAlerter (ref, closePopup) {
  useEffect(() => {
    /**
         * Alert if clicked on outside of element
         */
    function handleClickOutside (event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // console.log(closePopup)
        closePopup();
        // alert("You clicked outside of me!");
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, closePopup]);
}

const TopMenuBar = ({
  showSearch,
  setShowSearch,
  isFocused,
  setIsFocused,
  ...props
}) => {
  const [liveEvent, setLiveEvent] = useState(false);

  async function getLiveData () {
    const res = await axios({
      url: `${API_URL}/live`,
    });
    const { data } = await res;
    return data;
  }

  useEffect(() => {
    getLiveData().then(res => {
      setLiveEvent(res.current_event);
    });
  }, []);

  const wrapperRef = useRef(null);

  const closePopup = () => {
    setShowSearch(false);
    setIsFocused(false);
  };

  useOutsideAlerter(wrapperRef, closePopup);

  return (
    <>
            <div className={`menu__bar ${liveEvent ? 'searchRight' : ''}`} ref={wrapperRef}>
              <SearchBar
                    showSearch={showSearch}
                    setShowSearch={setShowSearch}
                    isFocused={isFocused}
                    setIsFocused={setIsFocused}
                />
                <Link to='/live' className='menu__bar__live' style={liveEvent ? {} : { display: 'none' }}>
                    <p className='menu__bar__live__icon' style={{ color: `${liveEvent ? '#ff0660' : 'white'}` }}>
                        <span>·</span> Live
                    </p>
                </Link>
            </div>
            <div
                className={`main__search__backdrop ${showSearch ? 'show' : ''}`}
                onClick={(e) => {
                    e.preventDefault();
                    closePopup();
                }}
            />
    </>
  );
};

TopMenuBar.propTypes = {
  setShowSearch: PropTypes.func,
  showSearch: PropTypes.bool,
  isFocused: PropTypes.bool,
  setIsFocused: PropTypes.func,
};

export default TopMenuBar;
